export default function About() {
  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/575d575ae5658fae8ecd43189cfca1d4.jpg"
                alt="Equipo Marin Construesfuerzo"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-amber-500 text-white p-8 rounded-xl shadow-xl">
              <div className="text-center">
                <p className="text-5xl font-bold">15+</p>
                <p className="text-sm font-medium mt-2">Años de Experiencia</p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Sobre <strong className="text-amber-500">Nosotros</strong>
            </h2>
            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              <strong>Marin Construesfuerzo SL</strong> es una empresa líder en <strong>construcción general en Arrecife, Lanzarote</strong>, con más de 15 años de experiencia en el sector. Nos especializamos en ofrecer soluciones integrales de construcción y reformas para proyectos residenciales y comerciales en toda la isla.
            </p>
            <p className="text-base text-gray-700 mb-6 leading-relaxed">
              Nuestro equipo de profesionales certificados se dedica a proporcionar servicios de la más alta calidad en <strong>pintura, electricidad, fontanería, pladur, impermeabilizaciones</strong> y más. Cada proyecto es tratado con el máximo cuidado y atención al detalle.
            </p>
            <p className="text-base text-gray-700 mb-8 leading-relaxed">
              En <strong>Marin Construesfuerzo</strong>, entendemos que tu hogar o negocio es una inversión importante. Por eso, trabajamos con materiales de primera calidad y las mejores técnicas de <strong>construcción en Lanzarote</strong> para garantizar resultados duraderos y satisfactorios.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-line text-xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Calidad Garantizada</h4>
                  <p className="text-sm text-gray-600">Materiales premium y acabados perfectos</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Equipo Profesional</h4>
                  <p className="text-sm text-gray-600">Técnicos certificados y experimentados</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Puntualidad</h4>
                  <p className="text-sm text-gray-600">Cumplimos plazos de entrega</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-price-tag-3-line text-xl text-amber-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Precios Justos</h4>
                  <p className="text-sm text-gray-600">Presupuestos transparentes sin sorpresas</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-amber-500">
              <p className="text-sm text-gray-700 italic">
                "Nuestro compromiso es transformar tus ideas en realidad, ofreciendo servicios de <strong>construcción en Lanzarote</strong> que superan las expectativas. Tu satisfacción es nuestra mejor carta de presentación."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
